import pipe from "../../lib/core/functional/pipe";

import formControl from "./formControl";
import resultsControl from "./resultsControl";
import feedbackControl from "./feedbackControl";

const votingPipeline = pipe(formControl, resultsControl, feedbackControl);

export default function assemblerVoting(context, listicle) {
    votingPipeline({ listicle, context });
}
